/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchRemoveListingDiscountPriceRequestV2,
    BatchUpdateListingDiscountPriceRequest,
    BatchUpdateListingDiscountPriceRequestV2,
    CreateStoreListingRequest,
    CreateStoreListingResponse,
    EditStoreListingRequest,
    ImportStoreListing,
    LinkListingsToProductCategoryRequest,
    ModerateStoreListingRequest,
    PatchStoreListingRequest,
    SignedUrlResponse,
    StoreListingRatingRequest,
    StoreListingRatingResponse,
} from '../models';

export interface StoreListingApiControllerBatchRemoveListingDiscountPriceRequest {
    storeId: string;
}

export interface StoreListingApiControllerBatchRemoveListingDiscountPriceV2Request {
    storeId: string;
    batchRemoveListingDiscountPriceRequestV2: BatchRemoveListingDiscountPriceRequestV2;
}

export interface StoreListingApiControllerBatchUpdateListingDiscountPriceRequest {
    storeId: string;
    batchUpdateListingDiscountPriceRequest: BatchUpdateListingDiscountPriceRequest;
}

export interface StoreListingApiControllerBatchUpdateListingDiscountPriceV2Request {
    storeId: string;
    batchUpdateListingDiscountPriceRequestV2: BatchUpdateListingDiscountPriceRequestV2;
}

export interface StoreListingApiControllerCreateStoreListingRequest {
    storeId: string;
    createStoreListingRequest: CreateStoreListingRequest;
}

export interface StoreListingApiControllerCreateStoreListingRatingRequest {
    storeId: string;
    listingId: string;
    storeListingRatingRequest: StoreListingRatingRequest;
}

export interface StoreListingApiControllerDeleteStoreListingRequest {
    storeId: string;
    listingId: string;
}

export interface StoreListingApiControllerEditStoreListingRequest {
    storeId: string;
    listingId: string;
    editStoreListingRequest: EditStoreListingRequest;
}

export interface StoreListingApiControllerGetDigitalProductAssetRequest {
    storeId: string;
    assetId: string;
}

export interface StoreListingApiControllerImportStoreListingsRequest {
    storeId: string;
    importStoreListing: ImportStoreListing;
}

export interface StoreListingApiControllerLinkProductCategoryRequest {
    storeId: string;
    linkListingsToProductCategoryRequest: LinkListingsToProductCategoryRequest;
}

export interface StoreListingApiControllerModerateStoreListingRequest {
    storeId: string;
    listingId: string;
    moderateStoreListingRequest: ModerateStoreListingRequest;
}

export interface StoreListingApiControllerPatchStoreListingRequest {
    storeId: string;
    listingId: string;
    patchStoreListingRequest: PatchStoreListingRequest;
}

export interface StoreListingApiControllerRestockAllocateStoreListingRequest {
    storeId: string;
    listingId: string;
}

export interface StoreListingApiControllerStartAllocateStoreListingRequest {
    storeId: string;
    listingId: string;
}

/**
 * 
 */
export class StoreListingApi extends runtime.BaseAPI {

    /**
     */
    async storeListingApiControllerBatchRemoveListingDiscountPriceRaw(requestParameters: StoreListingApiControllerBatchRemoveListingDiscountPriceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerBatchRemoveListingDiscountPrice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:batchRemoveDiscountPrice`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerBatchRemoveListingDiscountPrice(requestParameters: StoreListingApiControllerBatchRemoveListingDiscountPriceRequest): Promise<void> {
        await this.storeListingApiControllerBatchRemoveListingDiscountPriceRaw(requestParameters);
    }

    /**
     */
    async storeListingApiControllerBatchRemoveListingDiscountPriceV2Raw(requestParameters: StoreListingApiControllerBatchRemoveListingDiscountPriceV2Request): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerBatchRemoveListingDiscountPriceV2.');
        }

        if (requestParameters.batchRemoveListingDiscountPriceRequestV2 === null || requestParameters.batchRemoveListingDiscountPriceRequestV2 === undefined) {
            throw new runtime.RequiredError('batchRemoveListingDiscountPriceRequestV2','Required parameter requestParameters.batchRemoveListingDiscountPriceRequestV2 was null or undefined when calling storeListingApiControllerBatchRemoveListingDiscountPriceV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/stores/{storeId}:batchRemoveDiscountPrice`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchRemoveListingDiscountPriceRequestV2,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerBatchRemoveListingDiscountPriceV2(requestParameters: StoreListingApiControllerBatchRemoveListingDiscountPriceV2Request): Promise<void> {
        await this.storeListingApiControllerBatchRemoveListingDiscountPriceV2Raw(requestParameters);
    }

    /**
     */
    async storeListingApiControllerBatchUpdateListingDiscountPriceRaw(requestParameters: StoreListingApiControllerBatchUpdateListingDiscountPriceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerBatchUpdateListingDiscountPrice.');
        }

        if (requestParameters.batchUpdateListingDiscountPriceRequest === null || requestParameters.batchUpdateListingDiscountPriceRequest === undefined) {
            throw new runtime.RequiredError('batchUpdateListingDiscountPriceRequest','Required parameter requestParameters.batchUpdateListingDiscountPriceRequest was null or undefined when calling storeListingApiControllerBatchUpdateListingDiscountPrice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}:batchUpdateDiscountPrice`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchUpdateListingDiscountPriceRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerBatchUpdateListingDiscountPrice(requestParameters: StoreListingApiControllerBatchUpdateListingDiscountPriceRequest): Promise<void> {
        await this.storeListingApiControllerBatchUpdateListingDiscountPriceRaw(requestParameters);
    }

    /**
     */
    async storeListingApiControllerBatchUpdateListingDiscountPriceV2Raw(requestParameters: StoreListingApiControllerBatchUpdateListingDiscountPriceV2Request): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerBatchUpdateListingDiscountPriceV2.');
        }

        if (requestParameters.batchUpdateListingDiscountPriceRequestV2 === null || requestParameters.batchUpdateListingDiscountPriceRequestV2 === undefined) {
            throw new runtime.RequiredError('batchUpdateListingDiscountPriceRequestV2','Required parameter requestParameters.batchUpdateListingDiscountPriceRequestV2 was null or undefined when calling storeListingApiControllerBatchUpdateListingDiscountPriceV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/stores/{storeId}:batchUpdateDiscountPrice`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchUpdateListingDiscountPriceRequestV2,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerBatchUpdateListingDiscountPriceV2(requestParameters: StoreListingApiControllerBatchUpdateListingDiscountPriceV2Request): Promise<void> {
        await this.storeListingApiControllerBatchUpdateListingDiscountPriceV2Raw(requestParameters);
    }

    /**
     */
    async storeListingApiControllerCreateStoreListingRaw(requestParameters: StoreListingApiControllerCreateStoreListingRequest): Promise<runtime.ApiResponse<CreateStoreListingResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerCreateStoreListing.');
        }

        if (requestParameters.createStoreListingRequest === null || requestParameters.createStoreListingRequest === undefined) {
            throw new runtime.RequiredError('createStoreListingRequest','Required parameter requestParameters.createStoreListingRequest was null or undefined when calling storeListingApiControllerCreateStoreListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createStoreListingRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerCreateStoreListing(requestParameters: StoreListingApiControllerCreateStoreListingRequest): Promise<CreateStoreListingResponse> {
        const response = await this.storeListingApiControllerCreateStoreListingRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeListingApiControllerCreateStoreListingRatingRaw(requestParameters: StoreListingApiControllerCreateStoreListingRatingRequest): Promise<runtime.ApiResponse<StoreListingRatingResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerCreateStoreListingRating.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling storeListingApiControllerCreateStoreListingRating.');
        }

        if (requestParameters.storeListingRatingRequest === null || requestParameters.storeListingRatingRequest === undefined) {
            throw new runtime.RequiredError('storeListingRatingRequest','Required parameter requestParameters.storeListingRatingRequest was null or undefined when calling storeListingApiControllerCreateStoreListingRating.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}/ratings`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.storeListingRatingRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerCreateStoreListingRating(requestParameters: StoreListingApiControllerCreateStoreListingRatingRequest): Promise<StoreListingRatingResponse> {
        const response = await this.storeListingApiControllerCreateStoreListingRatingRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeListingApiControllerDeleteStoreListingRaw(requestParameters: StoreListingApiControllerDeleteStoreListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerDeleteStoreListing.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling storeListingApiControllerDeleteStoreListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerDeleteStoreListing(requestParameters: StoreListingApiControllerDeleteStoreListingRequest): Promise<void> {
        await this.storeListingApiControllerDeleteStoreListingRaw(requestParameters);
    }

    /**
     */
    async storeListingApiControllerEditStoreListingRaw(requestParameters: StoreListingApiControllerEditStoreListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerEditStoreListing.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling storeListingApiControllerEditStoreListing.');
        }

        if (requestParameters.editStoreListingRequest === null || requestParameters.editStoreListingRequest === undefined) {
            throw new runtime.RequiredError('editStoreListingRequest','Required parameter requestParameters.editStoreListingRequest was null or undefined when calling storeListingApiControllerEditStoreListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editStoreListingRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerEditStoreListing(requestParameters: StoreListingApiControllerEditStoreListingRequest): Promise<void> {
        await this.storeListingApiControllerEditStoreListingRaw(requestParameters);
    }

    /**
     */
    async storeListingApiControllerGetDigitalProductAssetRaw(requestParameters: StoreListingApiControllerGetDigitalProductAssetRequest): Promise<runtime.ApiResponse<SignedUrlResponse>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerGetDigitalProductAsset.');
        }

        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
            throw new runtime.RequiredError('assetId','Required parameter requestParameters.assetId was null or undefined when calling storeListingApiControllerGetDigitalProductAsset.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/digital-product-assets/{assetId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters.assetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerGetDigitalProductAsset(requestParameters: StoreListingApiControllerGetDigitalProductAssetRequest): Promise<SignedUrlResponse> {
        const response = await this.storeListingApiControllerGetDigitalProductAssetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async storeListingApiControllerImportStoreListingsRaw(requestParameters: StoreListingApiControllerImportStoreListingsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerImportStoreListings.');
        }

        if (requestParameters.importStoreListing === null || requestParameters.importStoreListing === undefined) {
            throw new runtime.RequiredError('importStoreListing','Required parameter requestParameters.importStoreListing was null or undefined when calling storeListingApiControllerImportStoreListings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings:import`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.importStoreListing,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerImportStoreListings(requestParameters: StoreListingApiControllerImportStoreListingsRequest): Promise<void> {
        await this.storeListingApiControllerImportStoreListingsRaw(requestParameters);
    }

    /**
     */
    async storeListingApiControllerLinkProductCategoryRaw(requestParameters: StoreListingApiControllerLinkProductCategoryRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerLinkProductCategory.');
        }

        if (requestParameters.linkListingsToProductCategoryRequest === null || requestParameters.linkListingsToProductCategoryRequest === undefined) {
            throw new runtime.RequiredError('linkListingsToProductCategoryRequest','Required parameter requestParameters.linkListingsToProductCategoryRequest was null or undefined when calling storeListingApiControllerLinkProductCategory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings:linkProductCategory`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.linkListingsToProductCategoryRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerLinkProductCategory(requestParameters: StoreListingApiControllerLinkProductCategoryRequest): Promise<void> {
        await this.storeListingApiControllerLinkProductCategoryRaw(requestParameters);
    }

    /**
     */
    async storeListingApiControllerModerateStoreListingRaw(requestParameters: StoreListingApiControllerModerateStoreListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerModerateStoreListing.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling storeListingApiControllerModerateStoreListing.');
        }

        if (requestParameters.moderateStoreListingRequest === null || requestParameters.moderateStoreListingRequest === undefined) {
            throw new runtime.RequiredError('moderateStoreListingRequest','Required parameter requestParameters.moderateStoreListingRequest was null or undefined when calling storeListingApiControllerModerateStoreListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}:moderate`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.moderateStoreListingRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerModerateStoreListing(requestParameters: StoreListingApiControllerModerateStoreListingRequest): Promise<void> {
        await this.storeListingApiControllerModerateStoreListingRaw(requestParameters);
    }

    /**
     */
    async storeListingApiControllerPatchStoreListingRaw(requestParameters: StoreListingApiControllerPatchStoreListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerPatchStoreListing.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling storeListingApiControllerPatchStoreListing.');
        }

        if (requestParameters.patchStoreListingRequest === null || requestParameters.patchStoreListingRequest === undefined) {
            throw new runtime.RequiredError('patchStoreListingRequest','Required parameter requestParameters.patchStoreListingRequest was null or undefined when calling storeListingApiControllerPatchStoreListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchStoreListingRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerPatchStoreListing(requestParameters: StoreListingApiControllerPatchStoreListingRequest): Promise<void> {
        await this.storeListingApiControllerPatchStoreListingRaw(requestParameters);
    }

    /**
     */
    async storeListingApiControllerRestockAllocateStoreListingRaw(requestParameters: StoreListingApiControllerRestockAllocateStoreListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerRestockAllocateStoreListing.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling storeListingApiControllerRestockAllocateStoreListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}/allocations:restock`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerRestockAllocateStoreListing(requestParameters: StoreListingApiControllerRestockAllocateStoreListingRequest): Promise<void> {
        await this.storeListingApiControllerRestockAllocateStoreListingRaw(requestParameters);
    }

    /**
     */
    async storeListingApiControllerStartAllocateStoreListingRaw(requestParameters: StoreListingApiControllerStartAllocateStoreListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling storeListingApiControllerStartAllocateStoreListing.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling storeListingApiControllerStartAllocateStoreListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/listings/{listingId}/allocations:allocate`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async storeListingApiControllerStartAllocateStoreListing(requestParameters: StoreListingApiControllerStartAllocateStoreListingRequest): Promise<void> {
        await this.storeListingApiControllerStartAllocateStoreListingRaw(requestParameters);
    }

}
